import { HorizBox, Pad } from 'component/basics';
import { ColoredBall, ColoredBallPill } from 'component/colorpill';
import { component, demoFile } from 'system/demo';
import { t } from 'util/stdtypes';

demoFile('component/colorpill');

component('ColoredBallPill', ColoredBallPill, {
    args: { label: t('!Label'), color: 'purple' },
});

function ColoredBallDemo() {
    return (
        <HorizBox center>
            <ColoredBall color='purple' size={16} />
            <Pad size={8} />
            <ColoredBall color='orange' size={16} />
        </HorizBox>
    );
}

component('ColoredBall', ColoredBallDemo);
